import React from 'react';
import './LegalPage.css';

function LegalNoticePage() {
  return (
    <div className="legal-page">
      <div className="legal-content">
        <h1 className="legal-page-title">LEGAL NOTICE AND GENERAL CONDITIONS OF USE</h1>

        <div className="legal-section">
          <h2>I. GENERAL INFORMATION</h2>
          <p>
            In compliance with the information duty set out in Law 34/2002 on Information Society Services
            and Electronic Commerce (LSSI-CE) of 11 July, the following general information about this
            website is provided:
          </p>
          <p>
            The ownership of this website, www.tabiagroup.com, (hereinafter, the Website) belongs to:
            TABIA GROUP S.L, with Tax ID: B16626871, whose contact details are:
          </p>
          <ul>
            <li>Address: Calle de la Gerreria, 26 1ºB, 07002 Palma De Mallorca</li>
            <li>Contact phone: 871533824</li>
            <li>Contact email: <a href="mailto:info@tabiagroup.com">info@tabiagroup.com</a></li>
          </ul>
        </div>

        <div className="legal-section">
          <h2>II. GENERAL TERMS AND CONDITIONS OF USE</h2>
          <h3>The subject matter of the conditions: The Website</h3>
          <p>
            The purpose of these General Conditions of Use (hereinafter, the Conditions) is to regulate
            access to and use of the Website. For the purposes of these Conditions, the Website shall be
            understood as: the external appearance of the screen interfaces, both in static and dynamic form,
            i.e. the navigation tree; and all elements integrated into both the screen interfaces and the
            navigation tree (hereinafter, Content) and all online services or resources that may be offered
            to Users (hereinafter, Services).
          </p>
          <p>
            TABIA GROUP reserves the right to modify, at any time and without prior notice, the presentation
            and configuration of the Website and the Content and Services incorporated therein. The User
            acknowledges and accepts that TABIA GROUP may at any time interrupt, disable and/or cancel any
            of these elements integrated into the Website or access to them.
          </p>
          <p>
            Access to the Website by the User is free of charge and, as a general rule, does not require the
            User to provide any consideration, except for the cost of connection through the
            telecommunications network provided by the access provider contracted by the User.
          </p>
          <p>Use of the Content does not require prior subscription or registration.</p>

          <h3>The User</h3>
          <p>
            Accessing, browsing and using the Website confers the status of User, which means that from the
            moment browsing begins, all the Conditions set out here are accepted, along with any subsequent
            modifications, without prejudice to the application of any mandatory legal regulations applicable
            in each case. Given the importance of the above, Users are advised to read them each time they
            visit the Website.
          </p>
          <p>
            The TABIA GROUP Website provides a wide variety of information, services and data. The User
            assumes responsibility for making correct use of the Website. This responsibility extends to:
          </p>
          <ul>
            <li>
              Use of the information, Content and/or Services and data offered by TABIA GROUP in a manner
              that is not contrary to these Conditions, the law, morality or public order, or that could in
              any other way cause harm to the rights of third parties or the functioning of the Website itself.
            </li>
            <li>
              The truthfulness and legality of information provided by the User in forms extended by TABIA
              GROUP to access certain Content or Services offered by the Website. In all cases, the User
              shall immediately notify TABIA GROUP of any fact that permits improper use of the information
              registered in such forms, such as, but not limited to, theft, loss, or unauthorised access to
              identifiers and/or passwords, in order to proceed to their immediate cancellation.
            </li>
          </ul>
          <p>
            Merely accessing this Website does not imply the establishment of any commercial relationship
            between TABIA GROUP and the User.
          </p>
          <p>
            Always in compliance with current legislation, this TABIA GROUP Website is aimed at all persons,
            regardless of age, who can access and/or browse the pages of the Website.
          </p>
        </div>

        <div className="legal-section">
          <h2>III. WEBSITE ACCESS AND NAVIGATION: EXCLUSION OF WARRANTIES AND LIABILITY</h2>
          <p>
            TABIA GROUP does not guarantee the continuity, availability or usefulness of the Website, or
            the Content or Services. TABIA GROUP will do its best to ensure the proper functioning of the
            Website; however, it does not accept responsibility or guarantee that access to this Website
            will be uninterrupted or free from errors.
          </p>
          <p>
            Nor does it accept responsibility or guarantee that the content or software accessible through
            this Website is free from errors or will not cause damage to the User's computer system
            (software and hardware). In no event shall TABIA GROUP be liable for any losses, damages or
            harm of any kind arising from access, browsing and use of the Website, including but not limited
            to those caused to computer systems or those caused by the introduction of viruses.
          </p>
          <p>
            TABIA GROUP is also not responsible for any damage that may be caused to users through improper
            use of this Website. In particular, it accepts no responsibility whatsoever for any outages,
            interruptions, failures or defects in telecommunications that may occur.
          </p>
        </div>

        <div className="legal-section">
          <h2>IV. LINK POLICY</h2>
          <p>
            Any User or third party who creates a hyperlink from a web page on another, different website
            to the TABIA GROUP Website should be aware that:
          </p>
          <ul>
            <li>
              Reproduction — in whole or in part — of any of the Content and/or Services of the Website
              is not permitted without the express authorisation of TABIA GROUP.
            </li>
            <li>
              No false, inaccurate or incorrect statements about the TABIA GROUP Website, or about its
              Content and/or Services, are permitted.
            </li>
            <li>
              With the exception of the hyperlink itself, the website on which the hyperlink is established
              shall not contain any element from this Website that is protected as intellectual property
              under Spanish law, unless expressly authorised by TABIA GROUP.
            </li>
            <li>
              The establishment of the hyperlink shall not imply the existence of any relationship between
              TABIA GROUP and the owner of the website from which it is made, nor the knowledge or
              acceptance by TABIA GROUP of the content, services and/or activities offered on that website,
              and vice versa.
            </li>
          </ul>
        </div>

        <div className="legal-section">
          <h2>V. INTELLECTUAL AND INDUSTRIAL PROPERTY</h2>
          <p>
            TABIA GROUP, either on its own or as an assignee, holds all intellectual and industrial property
            rights to the Website and the elements contained therein (including but not limited to images,
            sound, audio, video, software or text, trademarks or logos, colour combinations, structure and
            design, selection of materials used, computer programs required for its operation, access and
            use, etc.). These are therefore works protected as intellectual property under Spanish law, to
            which both Spanish and EU regulations in this field apply, as well as international treaties on
            the subject signed by Spain.
          </p>
          <p>
            All rights reserved. Pursuant to the provisions of the Intellectual Property Law, reproduction,
            distribution and public communication, including the making available modality, of all or part
            of the content of this website for commercial purposes, in any medium and by any technical
            means, without the authorisation of TABIA GROUP, is expressly prohibited.
          </p>
          <p>
            The User agrees to respect the intellectual and industrial property rights of TABIA GROUP. The
            User may view the elements of the Website or even print, copy and store them on the hard drive
            of their computer or any other physical medium, provided this is exclusively for personal use.
            However, the User may not delete, alter or manipulate any protection device or security system
            installed on the Website.
          </p>
          <p>
            If the User or a third party considers that any of the Content on the Website constitutes a
            violation of intellectual property rights, they must immediately notify TABIA GROUP through the
            contact details in the GENERAL INFORMATION section of this Legal Notice and General Conditions
            of Use.
          </p>
        </div>

        <div className="legal-section">
          <h2>VI. LEGAL ACTIONS, APPLICABLE LEGISLATION AND JURISDICTION</h2>
          <p>
            TABIA GROUP reserves the right to bring any civil or criminal actions it considers necessary
            for improper use of the Website and Content, or for breach of these Conditions.
          </p>
          <p>
            The relationship between the User and TABIA GROUP shall be governed by the regulations in
            force and applicable in Spanish territory. Should any dispute arise in connection with the
            interpretation and/or application of these Conditions, the parties shall submit their disputes
            to ordinary jurisdiction, submitting to the judges and courts that correspond in accordance
            with the law.
          </p>
        </div>

      </div>
    </div>
  );
}

export default LegalNoticePage;
